import { ReactNode } from "react";
import {
  AreaKeyInfo,
  BathroomsKeyInfo,
  BedroomsKeyInfo,
  CouncilTaxBandKeyInfo,
  TenureKeyInfo,
  EpcRatingKeyInfo,
  ReceptionRoomsKeyInfo,
  DepositKeyInfo,
  LeaseLengthKeyInfo,
} from "./key-info.tsx";
import { usePropertyDetailsContext } from "./contexts/property-details-context.tsx";

const KeyInfoItem = ({ children }: { children: ReactNode }) => <li className="flex justify-start">{children}</li>;

export interface PropertyKeyInfoListProps {
  className?: string;
}

export const PropertyKeyInfoList = ({ className }: PropertyKeyInfoListProps) => {
  const { beds, bathrooms, receptionRooms, metricArea, epc, councilTaxBand, tenure, deposit, leaseLength, rental } =
    usePropertyDetailsContext();
  return (
    <ul aria-label="Property details" className={className}>
      {beds != null && beds > 0 && (
        <KeyInfoItem>
          <BedroomsKeyInfo bedrooms={beds} />
        </KeyInfoItem>
      )}
      {bathrooms != null && bathrooms > 0 && (
        <KeyInfoItem>
          <BathroomsKeyInfo bathrooms={bathrooms} />
        </KeyInfoItem>
      )}
      {receptionRooms != null && receptionRooms > 0 && (
        <KeyInfoItem>
          <ReceptionRoomsKeyInfo receptionRooms={receptionRooms} />
        </KeyInfoItem>
      )}
      {metricArea != null && metricArea > 0 && (
        <KeyInfoItem>
          <AreaKeyInfo metresSquared={metricArea} />
        </KeyInfoItem>
      )}
      {epc && (
        <KeyInfoItem>
          <EpcRatingKeyInfo rating={epc} />
        </KeyInfoItem>
      )}
      {councilTaxBand && (
        <KeyInfoItem>
          <CouncilTaxBandKeyInfo band={councilTaxBand} />
        </KeyInfoItem>
      )}
      {rental === false && tenure && (
        <KeyInfoItem>
          <TenureKeyInfo tenure={tenure} />
        </KeyInfoItem>
      )}
      {leaseLength != null && leaseLength > 0 && (
        <KeyInfoItem>
          <LeaseLengthKeyInfo leaseLength={leaseLength} rental={rental ?? false} />
        </KeyInfoItem>
      )}
      {deposit != null && deposit > 0 && (
        <KeyInfoItem>
          <DepositKeyInfo deposit={deposit} />
        </KeyInfoItem>
      )}
    </ul>
  );
};
